export const FISP_TV_ADMIN_STORAGE_KEY = "fisp-tv-admin-session";

export const FISP_TV_HOME_PATH = "/fisp-tv";
export const FISP_TV_ADMIN_LOGIN_PATH = "/fisp-tv/login";
export const FISP_TV_ADMIN_HOME_PATH = "/fisp-tv/admin";

export const FISP_TV_ADMIN_MENU = [
    {
        id: "create",
        label: "Agregar nota",
        to: `${FISP_TV_ADMIN_HOME_PATH}/crear-nota`,
        description: "Alta de contenido con imagen, cuerpo, categoría y fecha de publicación.",
    },
    {
        id: "edit",
        label: "Editar nota",
        to: `${FISP_TV_ADMIN_HOME_PATH}/editar-nota`,
        description: "Actualización de notas existentes, relacionadas y programación.",
    },
    {
        id: "preview",
        label: "Previsualizar nota",
        to: `${FISP_TV_ADMIN_HOME_PATH}/previsualizar-nota`,
        description: "Revisión de notas programadas y chequeo del contenido antes de publicar.",
    },
    {
        id: "metrics",
        label: "Métricas",
        to: `${FISP_TV_ADMIN_HOME_PATH}/metricas`,
        description: "Seguimiento de vistas para las últimas notas publicadas.",
    },
    {
        id: "home",
        label: "Editar home",
        to: `${FISP_TV_ADMIN_HOME_PATH}/editar-home`,
        description: "Espacio reservado para la próxima etapa de edición de portada.",
    },
];

export const FISP_TV_ADMIN_CATEGORY_OPTIONS = [
    { label: "Desde Adentro", value: "desde-adentro" },
    { label: "Segunda Opinión", value: "segunda-opinion" },
    { label: "El Nudo", value: "el-nudo" },
    { label: "Inspirando el Cambio", value: "inspirando-el-cambio" },
    { label: "Editoriales", value: "opinion" },
    { label: "Real Food", value: "real-food" },
    { label: "Vida Sana", value: "vida-sana" },
    { label: "Medfiles", value: "medfiles" },
    { label: "Eso que no sabías", value: "eso-que-no-sabias" },
    { label: "TecnoFISP", value: "tecno-fisp" },
    { label: "En Foco", value: "en-foco" },
    { label: "DataFISP", value: "data-fisp" },
];

const FISP_TV_LEGACY_CATEGORY_OPTIONS = [
    { label: "Medicina 5.0", value: "medicina-5" },
    { label: "Recetas", value: "recetas" },
];

const FISP_TV_ALL_CATEGORY_OPTIONS = [
    ...FISP_TV_ADMIN_CATEGORY_OPTIONS,
    ...FISP_TV_LEGACY_CATEGORY_OPTIONS,
];

function normalizeAdminText(value) {
    return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]+/g, " ")
        .trim()
        .toLowerCase();
}

export function resolveAdminCategoryValue(value) {
    const lookup = normalizeAdminText(value);
    const option = FISP_TV_ALL_CATEGORY_OPTIONS.find((item) => {
        return normalizeAdminText(item.value) === lookup || normalizeAdminText(item.label) === lookup;
    });

    return option?.value || "";
}

export function resolveAdminCategoryLabel(value) {
    const lookup = normalizeAdminText(value);
    const option = FISP_TV_ALL_CATEGORY_OPTIONS.find((item) => {
        return normalizeAdminText(item.value) === lookup || normalizeAdminText(item.label) === lookup;
    });

    return option?.label || String(value || "").trim();
}
